import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import ja from 'vuetify/es5/locale/ja.js'

export default new Vuetify({
    lang: {
        locales: {ja},
        current: 'ja'
      }
});
